module.controller('logoutCtrl', ['LogoutService', '$rootScope',
  function (LogoutService, $rootScope) {
    LogoutService.destroy();
  }]);
